import React from 'react'
import { observer } from 'mobx-react-lite'

import { useTheme } from '@mui/material/styles'

import { ConnectionsWidget } from '@mxenabled/web-widget-sdk'

import ConnectStatus from '../../common/components/ConnectStatus'
import { Drawer, useAccountStore, useGlobalCopyStore } from '../../common'
import { MemberConnectionStatus } from '../../common/constants/Connect'
import { CONNECTIONS_WIDGET_ID } from '../../common/constants/Connect'
import { useConnectStore } from '../../common/context/hooks'

interface ConnectionsDrawerProps {
  onClose: () => void
  showConnectionsWidget: boolean
  title: string
}

const ConnectionsDrawer: React.FC<ConnectionsDrawerProps> = ({
  onClose,
  showConnectionsWidget,
  title,
}) => {
  let connectionsWidget: ConnectionsWidget
  const { refreshAccounts } = useAccountStore()
  const { loadWidget } = useConnectStore()
  const { connect: connectCopy } = useGlobalCopyStore()
  const theme = useTheme()

  const [isLoading, setIsLoading] = React.useState(false)
  const [hasError, setHasError] = React.useState(false)

  React.useEffect(() => {
    if (showConnectionsWidget) {
      setIsLoading(true)
      loadWidget({ widget: 'connections_widget', mode: theme.palette.mode }).then((res) => {
        connectionsWidget = new ConnectionsWidget({
          container: `#${CONNECTIONS_WIDGET_ID}`,
          style: {
            border: 'none',
            height: 'calc(100% - 62px)',
            width: '100%',
            position: 'absolute',
          },
          url: res.url,
          onSsoUrlLoadError: () => {
            setIsLoading(false)
            setHasError(true)
          },
          onLoad: () => {
            setIsLoading(false)
            setHasError(false)
          },
        })
      })
    } else {
      setIsLoading(false)
      setHasError(false)
    }

    return () => {
      connectionsWidget?.unmount()
    }
  }, [showConnectionsWidget])

  return (
    <Drawer
      ariaLabelClose={connectCopy.close_connections_aria}
      isOpen={showConnectionsWidget}
      onClose={() => {
        onClose()
        refreshAccounts()
      }}
      title={title}
    >
      <div id={CONNECTIONS_WIDGET_ID}>
        {hasError && <ConnectStatus status={MemberConnectionStatus.Error} />}
        {isLoading && <ConnectStatus status={MemberConnectionStatus.Loading} />}
      </div>
    </Drawer>
  )
}

export default observer(ConnectionsDrawer)
